import * as Bluebird from "bluebird";
import h from "../helper/helper";
var LOCALSTORAGE_ERROR_DE = "Fehler!\n Kann Daten nicht lokal speichern!\n whispeer funktioniert ohne lokale Datenspeicherung (localstorage) nicht.\n Bitte aktivier es oder bitte uns um Hilfe: feedback@whispeer.de";
var LOCALSTORAGE_ERROR_EN = "Error!\n Can't store data locally!\n whispeer does not work without localstorage.\n Please enable it or ask us for help: feedback@whispeer.de";
var checkLocalStorage = function () {
    var rand = Math.random();
    try {
        localStorage.setItem("check-" + rand, "check-" + rand);
        if (localStorage.getItem("check-" + rand) === "check-" + rand) {
            localStorage.removeItem("check-" + rand);
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
};
if (!checkLocalStorage) {
    if (h.getLanguageFromPath() === "de") {
        alert(LOCALSTORAGE_ERROR_DE);
    }
    else {
        alert(LOCALSTORAGE_ERROR_EN);
    }
}
var Storage = /** @class */ (function () {
    function Storage(prefix) {
        var _this = this;
        this.get = function (key) {
            return localStorage.getItem(_this.calculateKey(key));
        };
        this.set = function (key, data) {
            return localStorage.setItem(_this.calculateKey(key), data);
        };
        this.remove = function (key) {
            return localStorage.removeItem(_this.calculateKey(key));
        };
        this.clear = function () {
            var usedKeys = Object.keys(localStorage);
            usedKeys.filter(function (key) {
                return key.indexOf(this._prefix) === 0;
            }, _this).forEach(function (key) {
                localStorage.setItem(key, "");
            });
            return Bluebird.resolve();
        };
        this.save = function () {
            return Bluebird.resolve();
        };
        this.calculateKey = function (key) {
            return _this._prefix + "." + key;
        };
        this.awaitLoading = function () { return Bluebird.resolve(); };
        this._prefix = prefix;
    }
    return Storage;
}());
export default Storage;



//////////////////
// WEBPACK FOOTER
// ./js/services/Storage.ts
// module id = null
// module chunks = 